import tokeys from 'tokeys';

export default tokeys(['DISPLAY_ALERT', 'HIDE_ALERT', "SHOW_ALERT_BOTTOM", "HIDE_ALERT_BOTTOM"]);
